module.exports = __webpack_public_path__ + "static/media/venture.8e3c4577.svg";